export default __webpack_public_path__ + "5bf1007a2fcc9ab226b0d4f0ebe5fd11.png";